export const ENTRYPOINT = process.env.VUE_APP_API_ENTRYPOINT || 'https://localhost:8443';
